import * as React from 'react';
import { BottomSheet } from '@/components/ui/BottomSheet';
import { usePWAInstall } from '@/hooks/usePWAInstall';
import { ArrowUpOnSquareIcon, PlusIcon } from '@heroicons/react/24/outline';

const DISMISS_KEY = 'pwa_install_dismissed';

export function InstallPrompt() {
  const { isStandalone, isIOS, canPrompt, promptInstall } = usePWAInstall();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (isStandalone) return;
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    // Show if we can prompt (Android) or this is iOS Safari (manual path).
    if (canPrompt || isIOS) {
      const t = setTimeout(() => setOpen(true), 4000);
      return () => clearTimeout(t);
    }
  }, [isStandalone, isIOS, canPrompt]);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setOpen(false);
  };

  const install = async () => {
    const outcome = await promptInstall();
    if (outcome !== 'unavailable') dismiss();
  };

  if (isStandalone) return null;

  return (
    <BottomSheet open={open} onOpenChange={(o) => (o ? setOpen(true) : dismiss())} title="Add to your home screen">
      <div className="space-y-4 pb-2">
        <p className="text-sm text-text-secondary">
          Install Second Brain AI for a full-screen, app-like experience with faster access.
        </p>

        {isIOS ? (
          <ol className="space-y-3 text-sm text-text-secondary">
            <li className="flex items-center gap-3">
              <ArrowUpOnSquareIcon className="h-5 w-5 flex-shrink-0 text-primary" />
              Tap the <span className="font-semibold">Share</span> button in Safari.
            </li>
            <li className="flex items-center gap-3">
              <PlusIcon className="h-5 w-5 flex-shrink-0 text-primary" />
              Choose <span className="font-semibold">Add to Home Screen</span>.
            </li>
          </ol>
        ) : (
          <button
            onClick={install}
            className="w-full rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-on-primary transition-colors hover:bg-primary/90"
          >
            Install app
          </button>
        )}

        <button onClick={dismiss} className="w-full py-2 text-sm font-medium text-text-muted hover:text-text-secondary">
          Not now
        </button>
      </div>
    </BottomSheet>
  );
}
